import gql from 'graphql-tag';

export const TOKEN_AUTH = gql`
  mutation tokenCreate($email: String!, $password: String!) {
    tokenCreate(email: $email, password: $password) {
      token
      user {
        id
        email
        isStaff
        lastName
        firstName
        mobileNumber
        mobileVerified
        emailVerified
        zendeskToken
        maccaronCart: cart(forMgs: false) {
          token
          quantity
          forMgs
        }
        mgsCart: cart(forMgs: true) {
          token
          quantity
          forMgs
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CART_MERGE = gql`
  mutation cartMerge($cartId: ID!) {
    cartMerge(cartId: $cartId) {
      cart {
        token
        quantity
        forMgs
      }
      errors {
        field
        message
      }
    }
  }
`;
